export default "__VITE_ASSET__CuR0Dp2K__"